export interface IJSHelperService {
    deepObjectClone: (object: Object) => any,
}

const JSHelperService: IJSHelperService = {

    deepObjectClone: (object: any) => {

        // if(typeof(window.structuredClone) != "undefined"){
        //     return structuredClone(object);
        // }

        if (object == null || typeof (object) !== 'object') {
            // This 
            return object;
        }

        if (object instanceof Date) {
            const copy = new Date();
            copy.setTime(object.getTime());
            return copy;
        }

        if (object instanceof Array) {
            const copy = [];
            for (var i = 0, len = object.length; i < len; i++) {
                copy[i] = JSHelperService.deepObjectClone(object[i]);
            }
            return copy;
        }

        if (object instanceof Object) {
            const copy = new object.constructor();
            for (const key in object) {
                copy[key] = JSHelperService.deepObjectClone(object[key]);
            }
            return copy;
        }

        throw new Error("Unable to copy obj! Its type isn't supported.");
    }
}

export default JSHelperService;